import CrudBaseService from "@/services/CrudBaseService";

export default class RegionService extends CrudBaseService {
  constructor() {
    super('odoo/region');
  }

  findAllActivated() {
    return this.http.get(`${this._serviceName}/activated`);
  }
}
